<template>
  <div class="pos-id-flags d-flex flex-wrap align-items-center">
    <b-badge
      v-if="hasSpecial === true"
      variant="success"
      class="mr-1 mb-1"
      title="此 pos-id 已登記白名單（可對應多部影片）"
    >
      白名單
    </b-badge>
    <b-badge
      v-else-if="hasSpecial === false"
      variant="light"
      class="mr-1 mb-1"
      title="此 pos-id 未登記白名單"
    >
      非白名單
    </b-badge>
    <b-badge
      v-else
      variant="light"
      class="mr-1 mb-1"
      :title="unknownSpecialHint"
    >
      白名單 —
    </b-badge>

    <b-badge
      v-if="siblingState === 'yes'"
      variant="info"
      class="mr-1 mb-1"
      title="同一院線、同一 pos-id 還有其它匹配行（馬拉松 / 多片共用）"
    >
      多片共用（{{ siblingCount }} 筆）
    </b-badge>
    <b-badge
      v-else-if="siblingState === 'no'"
      variant="light"
      class="mr-1 mb-1"
      title="同一院線、同一 pos-id 沒有其它匹配行"
    >
      單片
    </b-badge>

    <b-badge v-if="unmatched" variant="danger" class="mr-1 mb-1">
      未匹配（film_id=0）
    </b-badge>
    <b-badge v-if="locked" variant="warning" class="mr-1 mb-1">已鎖定</b-badge>
  </div>
</template>

<script>
import { isUnmatchedRecord } from '@/utils/posId'

/**
 * P2/P1 共用的狀態標籤：白名單 / 多片共用 / 未匹配 / 鎖定。
 *
 * 契約要點（guide §2.1、§7.3-3）：
 *  - has_special / sibling_records 屬於「條件欄位」：沒請求就沒有值，
 *    因此 undefined 一律顯示「—」並提示可用篩選查，不能當成恆 false。
 */
export default {
  name: 'PosIdFlags',
  props: {
    record: {
      type: Object,
      default: null
    },
    // 未傳（undefined）＝ 不知道；傳空陣列＝ 確定沒有
    siblings: {
      type: Array,
      default: undefined
    },
    specialIds: {
      type: Array,
      default: undefined
    }
  },
  computed: {
    hasSpecial() {
      if (this.record && this.record.has_special === true) {
        return true
      }
      if (this.record && this.record.has_special === false) {
        return false
      }
      if (Array.isArray(this.specialIds)) {
        return this.specialIds.length > 0
      }
      return null
    },
    siblingState() {
      if (!Array.isArray(this.siblings)) {
        return 'unknown'
      }
      return this.siblings.length > 0 ? 'yes' : 'no'
    },
    siblingCount() {
      return Array.isArray(this.siblings) ? this.siblings.length : 0
    },
    unmatched() {
      return isUnmatchedRecord(this.record)
    },
    locked() {
      if (!this.record) {
        return false
      }
      return this.record.manual_linked === 1 || this.record.manual_linked === true
    },
    unknownSpecialHint() {
      return '此列表未請求 has_special 欄位，狀態未知；可用搜尋區的「只看已登記白名單」篩選查詢'
    }
  }
}
</script>

<style lang="scss" scoped>
.pos-id-flags {
  .badge {
    font-weight: 500;
  }
}
</style>
